module.exports = __webpack_public_path__ + "static/cover-hate-c410db05fdb0c9bfc95fb8ce9a4985a5.png";